//@ts-nocheck
import { Box } from '@jfs/ui-new'
import { memo, useEffect, useMemo, useState } from 'react'
import { Dimensions } from 'react-native'
import { DataProvider, LayoutProvider, RecyclerListView } from 'recyclerlistview'
interface CustomSectionListProps {
  renderRecentItem: any
  renderOperatorItem: any
  data: any[]
  renderHeader: any
  renderEmpty?: any
}

const OperatorSectionList = memo(
  ({ renderRecentItem, renderOperatorItem, data, renderHeader, renderEmpty }: CustomSectionListProps) => {
    const [_dataProvider, setDataProvider] = useState(
      new DataProvider((r1, r2) => {
        return r1 !== r2
      }).cloneWithRows(data),
    )

    useEffect(() => {
      setDataProvider((dataProvider) => dataProvider.cloneWithRows(data))
    }, [data])

    const _renderRecycleView = (_type: any, item: any, index: any) => {
      if (_type === 'HEADER') {
        return renderHeader({ item, index })
      } else if (_type === 'RECENTITEM') {
        return renderRecentItem({ item, index })
      } else {
        return renderOperatorItem({ item, index })
      }
    }
    const _layoutProvider = useMemo(
      () =>
        new LayoutProvider(
          (index) => {
            if (data[index] && data[index].type === 'HEADER') {
              return 'HEADER'
            } else if (data[index] && data[index].type === 'RECENTITEM') {
              return 'RECENTITEM'
            }
            return 'OPERATORITEM'
          },
          (type, dim) => {
            switch (type) {
              case 'HEADER':
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 48
                break
              case 'RECENTITEM':
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 70
                break
              case 'OPERATORITEM':
                dim.width = Math.round(Dimensions.get('window').width)
                dim.height = 70
                break
            }
          },
        ),
      [data],
    )

    return (
      <Box flex={1} testID="operatorList" alignSelf="stretch">
        {data && data.length > 0 && (
          <RecyclerListView
            style={{ flex: 1 }}
            dataProvider={_dataProvider}
            rowRenderer={_renderRecycleView}
            layoutProvider={_layoutProvider}
            canChangeSize={false}
            renderAheadOffset={400}
          />
        )}
        {(!data || data.length === 0) && renderEmpty && renderEmpty()}
      </Box>
    )
  },
)

export { OperatorSectionList }
